var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayMinSize, ArrayNotEmpty, IsArray, IsISO8601, IsOptional, IsUUID, } from 'class-validator';
/**
 * Body of `POST /v1/offices/:officeId/dunningRun` — kicks off a new
 * `DunningRun` for the office (the handler derives `officeLocationId` from
 * the selected invoices). All selected invoices must belong to the same
 * OfficeLocation, since the per-location in-flight invariant is the
 * scope of a single run.
 */
export class ExecuteDunningRunDto {
    invoiceIds;
    /**
     * Cutoff date (Stichtag) the candidate list was assembled with — the
     * payment-trust horizon ("invoices already overdue as of this date").
     * Recorded on the run for audit/replay; it is NOT re-validated against the
     * submitted `invoiceIds` (the operator's explicit selection wins). Omitting
     * records no cutoff. ISO-8601; the backend rejects future dates.
     */
    dueUpTo;
}
__decorate([
    IsArray(),
    ArrayNotEmpty(),
    ArrayMinSize(1),
    IsUUID('all', { each: true }),
    __metadata("design:type", Array)
], ExecuteDunningRunDto.prototype, "invoiceIds", void 0);
__decorate([
    IsOptional(),
    IsISO8601(),
    __metadata("design:type", String)
], ExecuteDunningRunDto.prototype, "dueUpTo", void 0);
/**
 * Response of `POST /v1/offices/:officeId/dunningRun`. The frontend uses
 * `dunningRunId` to start polling the status query and to drive the Running
 * / Completed sidebar views.
 */
export class ExecuteDunningRunResponseDto {
    dunningRunId;
}
//# sourceMappingURL=execute-dunning-run.dto.js.map